module.exports = __webpack_public_path__ + "img/thank-you-china-bg.c8ea348c.png";